import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Header } from "@/components/birthlife/Header";
import { Hero } from "@/components/birthlife/Hero";
import { Marquee } from "@/components/birthlife/Marquee";
import { About } from "@/components/birthlife/About";
import { Services } from "@/components/birthlife/Services";
import { Courses } from "@/components/birthlife/Courses";
import { Podcasts } from "@/components/birthlife/Podcasts";
import { FAQSection } from "@/components/birthlife/FAQSection";
import { Testimonials } from "@/components/birthlife/Testimonials";
import { InstagramGrid } from "@/components/birthlife/InstagramGrid";
import { BlogSection } from "@/components/birthlife/BlogSection";
import { Corporate } from "@/components/birthlife/Corporate";
import { Footer } from "@/components/birthlife/Footer";
import { WhatsAppFloat } from "@/components/birthlife/WhatsAppFloat";
import { BookingModal } from "@/components/birthlife/BookingModal";
import { useSite } from "@/lib/site";
import { Seo, websiteLd, organizationLd, personLd, localBusinessLd, faqPageLd } from "@/lib/seo";

const SECTION_COMPONENTS = {
  about: About,
  podcasts: Podcasts,
  marquee: Marquee,
  services: Services,
  courses: Courses,
  stories: Testimonials,
  faqs: FAQSection,
  blog: BlogSection,
  instagram: InstagramGrid,
  corporate: Corporate,
};

function HomeInner() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [preselected, setPreselected] = useState(null);
  const { content } = useSite();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const openBooking = (service = null) => {
    window.__tblTrack?.("book_cta_click", { service: service?.title || "general" });
    setPreselected(service?.title || null);
    setBookingOpen(true);
  };

  const ordered = [...(content.sections || [])]
    .filter((s) => s.visible !== false)
    .sort((a, b) => a.order - b.order);

  return (
    <div data-testid="home-page">
      <Seo
        path="/"
        jsonLd={[
          websiteLd(),
          organizationLd(content.settings),
          personLd(content.settings),
          localBusinessLd(content.settings, content.services || []),
          ...((content.faqs || []).length ? [faqPageLd(content.faqs)] : []),
        ]}
      />
      <Header onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        {ordered.map(({ key }) => {
          const Cmp = SECTION_COMPONENTS[key];
          if (!Cmp) return null;
          return key === "services" ? <Cmp key={key} onBook={openBooking} /> : <Cmp key={key} />;
        })}
      </main>
      <Footer onBook={openBooking} />
      <WhatsAppFloat />
      <BookingModal
        key={preselected || "default"}
        open={bookingOpen}
        onClose={() => setBookingOpen(false)}
        preselectedTitle={preselected}
      />
    </div>
  );
}

export default HomeInner;
